"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepComponent = exports.Steps = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("../../styles");
var FaCheck_1 = require("@react-icons/all-files/fa/FaCheck");
var styled_components_1 = require("styled-components");
var base_1 = require("../base");
var react_1 = require("react");
var RiSwapFill_1 = require("@react-icons/all-files/ri/RiSwapFill");
var context_1 = require("../../context/context");
var hooks_1 = require("../../hooks");
var Steps = function () {
    var steps = (0, context_1.useTwapContext)().state.swapSteps;
    return ((0, jsx_runtime_1.jsx)(StepsContainer, { children: (0, jsx_runtime_1.jsx)(StyledSteps, { children: steps === null || steps === void 0 ? void 0 : steps.map(function (step, index) { return (0, jsx_runtime_1.jsx)(StepComponent, { stepType: step }, step); }) }) }));
};
exports.Steps = Steps;
var StyledSteps = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    gap: 0,
});
var StepsContainer = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    position: "relative",
    gap: 0,
});
function StepComponent(_a) {
    var stepType = _a.stepType;
    var step = useStep(stepType);
    if (!step)
        return null;
    var selected = step.status !== "disabled" ? 1 : 0;
    return ((0, jsx_runtime_1.jsxs)(StepContainer, __assign({ className: "twap-step", selected: selected }, { children: [(0, jsx_runtime_1.jsxs)(StyledStep, { children: [(0, jsx_runtime_1.jsx)(Logo, { step: step }), (0, jsx_runtime_1.jsxs)(StyledTitleAndLink, { children: [(0, jsx_runtime_1.jsx)(StyledTitle, __assign({ className: "twap-step-title ".concat(selected ? "twap-step-title-selected" : "") }, { children: step.title })), step.link && ((0, jsx_runtime_1.jsx)(StyledLink, __assign({ href: step.link.url, target: "_blank", className: "twap-step-link" }, { children: step.link.text })))] }), (0, jsx_runtime_1.jsx)(StepStatus, { step: step })] }), (0, jsx_runtime_1.jsx)(StepDivider, { className: "twap-step-divider" })] })));
}
exports.StepComponent = StepComponent;
var StepStatus = function (_a) {
    var step = _a.step;
    if (step.status === "completed") {
        return ((0, jsx_runtime_1.jsx)(StyledSuccess, { children: (0, jsx_runtime_1.jsx)(FaCheck_1.FaCheck, {}) }));
    }
    if (step.status === "pending") {
        return (0, jsx_runtime_1.jsx)(StyledSpinner, {});
    }
    return null;
};
var StyledSpinner = (0, styled_components_1.styled)(base_1.Spinner)({
    width: 27,
    height: 27,
});
var useStep = function (step) {
    var _a;
    var _b = (0, context_1.useTwapContext)(), state = _b.state, srcToken = _b.srcToken;
    var createOrdertxHash = state.createOrdertxHash, approveTxHash = state.approveTxHash, wrapTxHash = state.wrapTxHash, swapStep = state.swapStep, createOrderSuccess = state.createOrderSuccess, wrapSuccess = state.wrapSuccess, approveSuccess = state.approveSuccess, swapSteps = state.swapSteps;
    var nativeToken = (_a = (0, hooks_1.useNetwork)()) === null || _a === void 0 ? void 0 : _a.native;
    return (0, react_1.useMemo)(function () {
        if (!step)
            return;
        var isWrapPending = swapStep === "wrap" && !wrapTxHash && !wrapSuccess;
        var isWrapLoading = swapStep === "wrap" && wrapTxHash && !wrapSuccess;
        var isApprovePending = swapStep === "approve" && !approveTxHash && !approveSuccess;
        var isApproveLoading = swapStep === "approve" && approveTxHash && !approveSuccess;
        var isCreatePending = swapStep === "createOrder" && !createOrdertxHash && !createOrderSuccess;
        var isCreateLoading = swapStep === "createOrder" && createOrdertxHash && !createOrderSuccess;
        if (step === "wrap") {
            return {
                title: isWrapLoading ? "Wrapping..." : "Wrap ".concat(nativeToken === null || nativeToken === void 0 ? void 0 : nativeToken.symbol),
                Icon: RiSwapFill_1.RiSwapFill,
                image: nativeToken === null || nativeToken === void 0 ? void 0 : nativeToken.logoUrl,
                status: wrapSuccess ? "completed" : isWrapLoading ? "loading" : isWrapPending ? "pending" : "disabled",
            };
        }
        if (step === "approve") {
            return {
                title: isApproveLoading ? "Approving..." : "Approve ".concat(srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol),
                image: srcToken === null || srcToken === void 0 ? void 0 : srcToken.logoUrl,
                status: approveSuccess ? "completed" : isApproveLoading ? "loading" : isApprovePending ? "pending" : "disabled",
            };
        }
        if (step === "createOrder") {
            return {
                title: isCreateLoading ? "Creating order..." : "Create Order",
                Icon: RiSwapFill_1.RiSwapFill,
                status: createOrderSuccess ? "completed" : isCreateLoading ? "loading" : isCreatePending ? "pending" : "disabled",
            };
        }
    }, [step, nativeToken, srcToken, createOrdertxHash, approveTxHash, wrapTxHash, swapStep, createOrderSuccess, wrapSuccess, approveSuccess, swapSteps]);
};
var StepContainer = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)(function (_a) {
    var selected = _a.selected;
    return ({
        gap: 0,
        "&:last-child": {
            ".twap-step-divider": {
                display: "none",
            },
        },
        ".twap-step-icon": {
            svg: {
                filter: "grayScale(".concat(selected ? 0 : 1, ")"),
                opacity: selected ? 1 : 0.5,
            },
        },
        img: {
            filter: "grayScale(".concat(selected ? 0 : 1, ")!important"),
            opacity: selected ? 1 : 0.5,
        },
        ".twap-step-link": {
            opacity: selected ? 1 : 0.7,
        },
    });
});
var StyledTitleAndLink = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    flex: 1,
    gap: 0,
});
var Logo = function (_a) {
    var step = _a.step;
    return ((0, jsx_runtime_1.jsx)(StyledStepLogo, __assign({ className: "twap-step-logo" }, { children: step.status === "loading" ? ((0, jsx_runtime_1.jsx)(base_1.Spinner, { size: 26 })) : step.image ? ((0, jsx_runtime_1.jsx)("img", { src: step.image, alt: step.title })) : step.Icon ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "twap-step-icon" }, { children: (0, jsx_runtime_1.jsx)(step.Icon, {}) }))) : null })));
};
var StyledLink = (0, styled_components_1.styled)("a")({
    color: "rgb(252, 114, 255)",
    fontSize: 12,
    lineHeight: "16px",
    textDecoration: "unset",
});
var StyledStep = (0, styled_components_1.styled)(styles_1.StyledRowFlex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  gap: 12px;\n  justify-content: flex-start;\n  height: 40px;\n"], ["\n  width: 100%;\n  gap: 12px;\n  justify-content: flex-start;\n  height: 40px;\n"])));
var StyledStepLogo = (0, styled_components_1.styled)("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  border-radius: 50%;\n  width: 26px;\n  height: 26px;\n  overflow: hidden;\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    position: relative;\n    z-index: 1;\n  }\n  .twap-step-icon {\n    svg {\n      width: 26px;\n      height: 26px;\n      fill: rgb(76, 130, 251);\n    }\n  }\n"], ["\n  position: relative;\n  border-radius: 50%;\n  width: 26px;\n  height: 26px;\n  overflow: hidden;\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    position: relative;\n    z-index: 1;\n  }\n  .twap-step-icon {\n    svg {\n      width: 26px;\n      height: 26px;\n      fill: rgb(76, 130, 251);\n    }\n  }\n"])));
var StyledTitle = (0, styled_components_1.styled)(styles_1.StyledText)({
    fontSize: 14,
    lineHeight: "16px",
});
var StyledSuccess = (0, styled_components_1.styled)("div")(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: auto;\n  color: white;\n  svg {\n    width: 14px;\n    height: 14px;\n  }\n"], ["\n  margin-left: auto;\n  color: white;\n  svg {\n    width: 14px;\n    height: 14px;\n  }\n"])));
var StepDivider = (0, styled_components_1.styled)("div")(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 2px;\n  height: 10px;\n  background-color: rgb(94, 94, 94);\n  margin-left: 12px;\n"], ["\n  width: 2px;\n  height: 10px;\n  background-color: rgb(94, 94, 94);\n  margin-left: 12px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
